import type { ConfigOverrideKey } from '#dn-types/host.ts';
import { configOverrideOrdering } from '#hooks/useSortedConfigOverrides.ts';
import type { OverrideMap } from '../../hooks/useOverrideMaps.ts';
import { makeHalves } from './makeHalves.ts';

/**
 * Sort a configMap into the same order as the Host Advanced form, and divide it into two halves,
 * with the first half containing an extra item if there's an odd number.
 */
export function makeConfigHalves(configMap: OverrideMap) {
  const order = configOverrideOrdering.filter(
    (key) => key !== 'graphite' && key !== 'prometheus'
  ) as ConfigOverrideKey[]; // The `.filter` doesn't narrow :(

  return makeHalves(configMap, order);
}
